var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRightShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 419,
    viewBox: "0 0 182 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.734 326.562C273.466 326.562 327.562 272.466 327.562 205.734C327.562 139.003 273.466 84.9062 206.734 84.9062C140.003 84.9062 85.9062 139.003 85.9062 205.734C85.9062 272.466 140.003 326.562 206.734 326.562Z",
    fill: "#C4D0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210 418C325.428 418 419 324.428 419 209C419 93.5725 325.428 0 210 0C94.5725 0 1 93.5725 1 209C1 324.428 94.5725 418 210 418Z",
    stroke: "#C4D0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightShare);
export default __webpack_public_path__ + "static/media/top_right_share.150a5801e5b46e6f41e32476d0850d4f.svg";
export { ForwardRef as ReactComponent };